import(/* webpackMode: "eager" */ "/var/www/luaitools.com/app/news/news.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/luaitools.com/components/LikeButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/luaitools.com/components/SiteHeader.tsx");
